import {useAccessToken} from "../../services/auth"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import Loading from "../../components/Loading/Loading"
import React from "react"
import {useParams} from "react-router"
import {getBank} from "../../resources/bank"
import {Bank as BankType} from "../../resources/bank"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSection} from "../../containers/MainSection/MainSection"
import RiskSettings from "../BankSettings/RiskSettings/RiskSettings"

interface PageProps {
	bank: BankType
}

function Page({bank}: PageProps) {
	return (
		<>
			<TitleBar breadcrumbs={[{text: "Banks", path: "/banks/"}]} title={bank.attributes.name} meta={[]} noBorder />
			<MainSection>
				<RiskSettings bankId={bank.id} title="Onboarding Rules" />
			</MainSection>
		</>
	)
}

export default function Bank() {
	const accessToken = useAccessToken()
	const {bankId = ""} = useParams<{bankId: string}>()

	const bank = useAsyncResult(() => getBank(accessToken, bankId), [])

	return (
		<AsyncResultComponent asyncResult={bank} pendingComponent={<Loading />}>
			{({value: bank}) => {
				return <Page bank={bank} />
			}}
		</AsyncResultComponent>
	)
}
